import './link.less';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const propTypes = {
	to: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.node,
	requestQueryString: PropTypes.string
};

class MakeLink extends Component {
	render() {
		const to = `${this.props.to}?${this.props.requestQueryString}`;
		return (
			<div className="hoc-link-wrapper">
				<Link to={to} className={this.props.className}>{ this.props.children }</Link>
			</div>
		);
	}
}

MakeLink.propTypes = propTypes;
export default MakeLink;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/link/index.js